import { render, staticRenderFns } from "./Contact-Us.vue?vue&type=template&id=37bdcfb4"
import script from "./Contact-Us.vue?vue&type=script&lang=js"
export * from "./Contact-Us.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports